import React from 'react';
import styled from 'styled-components';
import EditHeader from '../../../../components/molecule/EditHeader';
import Body from './Body';

const USER_PLACEHOLDER = require('../../../../assets/user_placeholder.jpg');

const Container = styled.div`
`
const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 160px;
  margin: auto;
  border-radius: 100%;
  overflow: hidden;
  background: url(${props => props.image}) no-repeat center center scroll;
  background-size: cover;
`

class Channel extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      editMode: false,
    }
  }

  submitForm = form => {
    const { onSubmit } = this.props;
    onSubmit(form, () => this.setEditMode(false));
  }

  setEditMode = (editMode) => {
    const { data, openChannelNameDialog } = this.props;

    // check for data.channel_name
    if (!data.channel_name) {
      openChannelNameDialog();
    } else {
      this.setState({ editMode });
    }
  }

  render() {
    const { data, onSubmit, ...other } = this.props;
    const { editMode } = this.state;

    return (
      <Container {...other}>
        <EditHeader
          label="Profile Photo"
          onClickEdit={() => this.setEditMode(true)}
          // onClickCancel={() => this.setEditMode(false)}
          inEdit={editMode}
        />
        {
          editMode ? (
            <Body
              initialValues={data}
              submit={this.submitForm}
              onClickCancel={() => this.setEditMode(false)}
            />
          ) : (
            <ImageWrapper image={data.picture && data.picture.url ? data.picture.url : USER_PLACEHOLDER} />
          )
        }
        
      </Container>
    );
  }
}

Channel.propTypes = {

};

export default Channel;
